import { createSelector } from 'reselect';
import { getTableLayout } from './router';
import * as R from 'ramda';

export const getLayoutIds = createSelector(getTableLayout, (layoutIds = {}) =>
  R.mergeRight({ header: [], sections: [], rows: [] }, layoutIds),
);
